import React from 'react';
import { ConfirmProvider } from 'material-ui-confirm';

const ConfirmOptions = ({ children }) => (
  <ConfirmProvider
    defaultOptions={{
      confirmationButtonProps: {
        color: 'success',
        autoFocus: true,
        'aria-label': 'confirm-ok',
        variant: 'contained',
      },
      cancellationButtonProps: { 'aria-label': 'confirm-cancel' },
    }}
  >
    {children}
  </ConfirmProvider>
);

export default ConfirmOptions;
